const uiActions = {
  INIT: 'UI_INIT',
  SET_ACTIVE_GROUP: 'UI_SET_ACTIVE_GROUP',
  SET_ACTIVE_PANEL: 'UI_SET_ACTIVE_PANEL',
  SET_APP_LOADING: 'UI_SET_APP_LOADING',
  SET_IS_MOBILE_VERIFICATION_METHOD: 'UI_SET_IS_MOBILE_VERIFICATION_METHOD',
  SET_MENU_OPEN: 'UI_SET_MENU_OPEN',
  SET_MODAL_OPEN: 'SET_MODAL_OPEN',

  init: () => ({
    type: uiActions.INIT,
  }),

  setActiveGroup: (groupName) => ({
    payload: {
      groupName,
    },
    type: uiActions.SET_ACTIVE_GROUP,
  }),

  setActivePanel: (panelName) => ({
    payload: {
      panelName,
    },
    type: uiActions.SET_ACTIVE_PANEL,
  }),

  setAppLoading: (payload) => ({
    payload,
    type: uiActions.SET_APP_LOADING,
  }),
  setMenuOpen: (payload) => ({
    payload,
    type: uiActions.SET_MENU_OPEN,
  }),
  setModalOpen: (payload) => ({
    payload,
    type: uiActions.SET_MODAL_OPEN,
  }),
};

export default uiActions;
